import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import AudioCallPageGrid from "../../common/AudioCall/AudioCallGridLayout";

const AudioCall = ({userId, mode}) => {
  return (
    <div style={{width: "100%", height: "100%" }}>
      <AudioCallPageGrid recipientId={userId} mode={mode}/>
    </div>
  );
};

export default AudioCall;
